import { Router } from 'components/Routing/Router';
import { observer } from 'mobx-react';
import React from 'react';
import './App.css';

export const App: React.FC = observer(() => {
    return <Router key="router" />;
});

export default App;
